<template>
  <div>

    <v-dialog
    v-model="error"
    width="500"
    >

      <v-card>
        <v-card-title
          class="headline red accent-3"
          primary-title
        >
          Warning Message
        </v-card-title>

        <v-card-text>
          {{errorMsg}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red accent-3"
            flat
            @click="setErrorZero"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-toolbar flat color="white">
      <v-toolbar-title>Validating Parameter</v-toolbar-title>
     <v-spacer></v-spacer>
       <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">Create</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-select 
                  v-model="editedItem.question_type_id"
                  :items="indexData.questionTypes"
                  item-text="instruction" 
                  item-value="id"
                  label="Instruction"
                  ></v-select>
                  <v-select 
                  v-model="editedItem.question_type_id"
                  :items="indexData.questionTypes"
                  item-text="description" 
                  item-value="id"
                  label="Description"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-select 
                  v-model="editedItem.ui_component_id"
                  :items="indexData.uiComponents"
                  item-text="name" 
                  item-value="id"
                  label="Ui Component"
                  ></v-select>
                  <v-text-field v-model="editedItem.name" label="Parameter Name"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="indexData.datas"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.created_by }}</td>
        <td class="text-xs-center">{{ props.item.question_type_id }}</td>
        <!-- <td class="text-xs-center">{{ props.item.question_types.description }}</td> -->
        <!-- <td class="text-xs-center">{{ props.item.ui_components.ui_category_id }}</td> -->
        <td class="text-xs-center">{{ props.item.ui_component_id }}</td>
        <td class="text-xs-center">{{ props.item.name }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'

 export default {
    data: () => ({
      dialog: false,
      search: '',
      apiUrl: 'validating-parameter',
      headers: [
        {
          text: 'Created By',
          align: 'center',
          sortable: false,
          value: 'created_by'
        },
        {
          text: 'Question Type ID',
          align: 'center',
          sortable: false,
          value: 'question_type_id'
        },
        // {
        //   text: 'Question Description',
        //   align: 'center',
        //   sortable: false,
        //   value: 'description'
        // },
        // {
        //   text: 'Ui Category',
        //   align: 'center',
        //   sortable: false,
        //   value: 'ui_category_id'
        // },
        {
          text: 'Ui Component ID',
          align: 'center',
          sortable: false,
          value: 'ui_component_id'
        },
        {
          text: 'Validating Parameter',
          align: 'center',
          sortable: false,
          value: 'name'
        },
        { text: 'Actions', align:'center',value: 'actions' },
      ],
      editedIndex: -1,
      editedItem: { 
        question_type_id: '',
        ui_component_id: '',
        name: ''
      },
      defaultItem: {  
        question_type_id: '',
        ui_component_id: '',
        name: ''
      }
    }),

    computed: {
      ...mapGetters(['isLoggedIn', 'indexData', 'error', 'statusCode', 'errorMsg']),
      formTitle () {
        return this.editedIndex === -1 ? 'Create' : 'Edit'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.$store.dispatch('setIndexData', [this.apiUrl])
      },

      setErrorZero () {
        this.$store.dispatch('setErrorZero')
      },

      editItem (item) {
        this.editedIndex = this.indexData.datas.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.indexData.datas.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.indexData.datas.splice(index, 1)
        this.$store.dispatch('delete', [this.apiUrl, item.id])
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        // console.log(this.editedIndex);
        if (this.editedIndex > -1) {
          this.$store.dispatch('store', [this.apiUrl, this.editedItem])
        } else {
          this.$store.dispatch('store', [this.apiUrl, this.editedItem])
        }
        this.close()
      }
    }
  }
</script>